import React, { useCallback, useEffect } from 'react';
import { Box, Card, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import {
  LOAD_SANTANDER_CLABES,
  loadSantanderClabes
} from 'src/store/actions/santanderClabeActions';
import {
  selectSantanderClabeCount,
  selectSantanderClabeList,
  selectSantanderClabeQueryOptions
} from 'src/store/selectors/santanderClabeSelectors';
import NotFoundRecords from 'src/components/NotFoundRecords';
import { useTranslation } from 'react-i18next';
import SantanderClabesTable from './SantanderClabesTable';

const SantanderClabesList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const clabes = useSelector(selectSantanderClabeList);
  const count = useSelector(selectSantanderClabeCount);
  const { page } = useSelector(selectSantanderClabeQueryOptions);
  const isLoading = useSelector(
    isLoadingSelector([LOAD_SANTANDER_CLABES.action])
  );

  useEffect(() => {
    dispatch(loadSantanderClabes());
  }, []);

  const handleChangePage = useCallback(
    (_, value) => {
      dispatch(loadSantanderClabes({ page: value }));
    },
    [dispatch]
  );

  if (!isLoading && count === 0) {
    return (
      <Card>
        <NotFoundRecords
          title={t('NOT_FOUND_RECORDS_MESSAGE.SANTANDER_CLABES_TITLE')}
          description={t(
            'NOT_FOUND_RECORDS_MESSAGE.SANTANDER_CLABES_DESCRIPTION'
          )}
        />
      </Card>
    );
  }

  return (
    <Box mt={3}>
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12}>
          <SantanderClabesTable
            clabes={clabes}
            loading={isLoading}
            count={count}
            page={page}
            handleChangePage={handleChangePage}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SantanderClabesList;
